import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
import ModalAlert from '../../components/modal/modal_alert';

const sagaMiddleware = createSagaMiddleware();
createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class CircleNameForm extends Component {
  render() {
    return <Root guideline={this.props.guideline} isApp={this.props.isApp} companyId={this.props.companyId} type={this.props.type}/>;
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameExists: false,
      loading: false,
      nameError: '',
    };
    this.onSubmitBtn = this.onSubmitBtn.bind(this);
    this.onChangeFields = this.onChangeFields.bind(this);
    this.onChangeOshikatsuCircle = this.onChangeOshikatsuCircle.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalIsOpen) {
      switch (nextProps.createStatus) {
        // case 'success':
        //   this.modalAlertSuccess.openModal();
        //   break;
        case 'error':
          this.modalAlertError.openModal();
          break;
      }
    }
  }
  /**
   * コンポーネントマウント時の処理
   */
  componentDidMount() {
    if (this.props.isDisableCreateCircle) {
      this.modalAlertDisableCreateCircle.openModal();
    }
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onSubmitBtn(e) {
    e.preventDefault();
    this.setState({loading: true});
    // 名前だけ入力、他はdefault値のcircle作成
    let circle = this.props.circle;
    circle.is_new_circle = true;
    circle.is_draft = false;
    circle.is_request_required = false;
    circle.recruit_status = true;
    circle.private_status = false;
    circle.delete_status = false;
    circle.about = '';
    circle.company_id = this.props.companyId;
    circle.type = this.props.type;
    circle.circle_name_type = this.props.type === 'department' ? 1 : 0;
    this.props.createNewCircle(circle);
    // データ作成に時間がかかるのでページ遷移を遅らせる
    setTimeout(() => {
      this.setState({loading: false});
      this.props.changePage("2");
    }, 2000);
  }

  onChangeFields(e) {
    const circleName = this.props.type === 'department' ? '部署' : 'サークル';
    let circle = this.props.circle;
    circle[e.target.id] = e.target.value;
    this.props.changeFields(circle);
    if (circle.name.length > 0) {
      this.setState({ nameExists: true });
    } else {
      this.setState({ nameExists: false });
    }
    if (circle.name.length > 30) {
      this.setState({ nameError: `${circleName}名は30文字以内で入力してください` });
    } else {
      this.setState({ nameError: '' });
    }
  }

  onChangeOshikatsuCircle(e) {
    let circle = { ...this.props.circle };
    circle.is_oshikatsu_circle = e.target.checked;
    this.props.changeFields(circle);
  }

  render() {
    const circleName = this.props.type === 'department' ? '部署' : 'サークル';
    const placeholderText = this.props.type === 'department' ? '人事部' : 'TOKYO食べ歩き隊';
    return (
      <div>
        <main
          className="bg-gray h-100 pt-3 min-vh-100"
          style={{
            paddingBottom: this.props.isApp == false ? '180px' : '72px',
          }}
        >
          <div className="container col-md-8 col-lg-6">
            <h1 className="font-weight-bold text-black-333 mt-4 mb-3 text-left text-fz-20px">
              まずは{circleName}名を決めましょう！
            </h1>
          </div>

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              {circleName}名
            </p>
            <p className="message-required d-inline-block mb-2 ml-1">必須</p>
            <p className="text-fz-small text-black-50">
              後から変更可能です
            </p>
            {this.state.nameError && (
              <p className="text-danger text-fz-small mt-0 mb-0">
                {this.state.nameError}
              </p>
            )}
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <input
                name=""
                id="name"
                className="p-0 w-100 textarea--eventreport"
                placeholder={placeholderText}
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.name}
              />
            </div>
          </div>
          <div className="container col-8 col-md-6 col-lg-4">
            <figure className="adjust-box-3x2 mt-5">
              <img
                alt="circle-new-top"
                className="adjust-box-inner w-100 lazyloaded"
                src="/img/circle-new-top.png"
              />
            </figure>
          </div>
          {this.props.type !== 'department' && (
            <div className="container col-md-8 col-lg-6">
            <p
              className="text-fz-11px text-black-444 pt-3"
              style={{ textAlign: 'center' }}
            >
                <span className="d-none d-md-block" style={{ fontSize: '15px' }}>
                  {circleName}やイベントの運営は3人以上の運営メンバーでやると、成功確率が劇的にUPします。
                  <br />
                  次ページで、共同運営者を招待することができます。
                </span>
                <span className="d-block d-md-none" style={{ fontSize: '12px' }}>
                  {circleName}やイベントの運営は3人以上の運営メンバーでやると、<br />
                  成功確率が劇的にUPします。<br />
                  次ページで、共同運営者を招待することができます。
                </span>
              </p>
            </div>
          )}
        </main>

        <div className="fixed-bottom" style={{ paddingBottom: '8px' }}>
          <div className="container col-md-8 col-lg-6">
            <div
              className="row"
              style={{ marginBottom: this.props.isApp == true ? '24px' : '' }}
            >
              <div className="col">
                <button
                  type="button"
                  onClick={this.onSubmitBtn}
                  id="is_draft"
                  value="false"
                  className={`a-button a-button__top a-button--orange text-white w-100 ${
                    this.props.isApp == false ? 'mb-2' : ''
                  }`}
                  disabled={this.state.nameExists === false || this.state.loading || this.state.nameError.length > 0}
                >
                  {this.state.loading ? '送信中...' : '次へ'}
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModalAlert
          ref={(c) => {
            this.modalAlertDisableCreateCircle = c;
          }}
          id="modalAlertDisableCreateCircle"
          title={`${circleName}作成上限を超えています。`}
          content="作成上限の10個を超えています。下書き状態での作成となります。"
        />
        {/* <ModalAlert
          ref={(c) => {
            this.modalAlertSuccess = c;
          }}
          id="modalAlertSuccess"
          title="初めてのイベントを作ろう！"
          content="サークル名が決まったら、初めてのイベントページを作りましょう。"
          approveFunc={this.toEventCreate}
        /> */}
        {/* 投稿失敗時 */}
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          id="modalAlertError"
          title={`${circleName}作成失敗`}
          content={`${circleName}作成に失敗しました。時間をおいてもう一度お試しください。`}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    guideline: ownProps.guideline,
    isApp: ownProps.isApp,
    type: ownProps.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFields: (circle) => {
      dispatch(Module.actions.changeFields({ circle }));
    },
    createNewCircle: (circle) => {
      dispatch(Module.actions.createNewCircle({ circle }));
    },
    changePage: (pageNum) => {
      dispatch(Module.actions.changePage({ pageNum }));
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);